// extracted by mini-css-extract-plugin
export var compact = "_nr-2";
export var phoneFrame = "_nr-0";
export var phoneScreen = "_nr-1";